export const navTitle = {
  demo1: '模板1',
  react1: '模板2',
  vue1: '模板3',
  icons: '图标列表',
  introduce: '使用文档',
  abc: '演示示例',
}
